import { useInfiniteQuery } from "@tanstack/react-query";

import { getPayments, GetPaymentsRequest } from "@/api";
import { OrderStatus } from "@/types";

const PER_PAGE = 4;

const useGetPayments = () => {
  return useInfiniteQuery({
    queryKey: ["payments"],
    queryFn: ({ pageParam }: { pageParam: GetPaymentsRequest["perPage"] }) => {
      return getPayments({
        page: pageParam ?? 1,
        perPage: PER_PAGE,
        status: OrderStatus.PAID,
      });
    },
    meta: {
      error: "Something went wrong... Try again",
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.meta.page + 1;
      return nextPage <= lastPage.meta.totalPages ? nextPage : undefined;
    },

    select: (response) => {
      return response.pages.flatMap(({ data }) => data);
    },
  });
};

export { useGetPayments };
